module.exports = require("@seddi/scene");